import React from 'react'
import {t} from '../lib/localize'
import {Link} from 'react-router-dom'

export default function ChangePasswordLink() {
  return <Link to='/passwords/self/edit' className='change-password-link'>{t('password.change.link')}</Link>
}


